/*
 * @Author: your name
 * @Date: 2021-09-16 11:31:05
 * @LastEditTime: 2024-09-09 10:43:09
 * @LastEditors: luodongming
 * @Description: In User Settings Edit
 * @FilePath: \yelink-ecm-portal-web\src\utils\request.js
 */
import axios from 'axios'
import { Message } from 'element-ui'
import handleUnauthorized from '@/utils/handleUnauthorized'
import store from '@/store'
import {
  canRefreshKeycloakToken,
  getCurrentAccessToken,
  refreshKeycloakToken
} from '@/utils/keycloak-token'
import qs from 'qs'

// create an axios instance
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
  timeout: 15 * 60 * 1000 // request timeout
})

service.interceptors.request.use(
  config => {
    const accessToken = getCurrentAccessToken()
    if (accessToken) {
      config.headers['Authorization'] = 'Bearer ' + accessToken
    }
    if (config.method === 'get') {
      config.paramsSerializer = function(params) {
        return qs.stringify(params, { arrayFormat: 'repeat' })
      }
    }
    return config
  },
  error => {
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
  */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  response => {
    // if the custom code is not 20000, it is judged as an error.
    /* if (res.code !== 20000) {
      Message({
        message: res.message || 'Error',
        type: 'error',
        duration: 5 * 1000
      })

      // 50008: Illegal token; 50012: Other clients logged in; 50014: Token expired;
      if (res.code === 50008 || res.code === 50012 || res.code === 50014) {
        // to re-login
        MessageBox.confirm('You have been logged out, you can cancel to stay on this page, or log in again', 'Confirm logout', {
          confirmButtonText: 'Re-Login',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }).then(() => {
          store.dispatch('user/resetToken').then(() => {
            location.reload()
          })
        })
      }
      return Promise.reject(new Error(res.message || 'Error'))
    } else {
      return res
    }*/
    if (response.request.responseType === 'blob') {
      // 文件下载
      return response
    } else {
      if (+response.data.code !== 0) {
        const { config = {}} = response
        let msg = response.data.message
        if (msg.toString().includes('升级任务正在执行中')) {
          msg = '正在执行升级操作，请稍等...'
        }
        if (Reflect.has(config, 'isSelfHandler') && config.isSelfHandler) {
          const err = new Error(response.data.message || 'Error')
          err.code = response.data.code
          err.data = response.data.data
          return Promise.reject(err)
        }
        Message({
          message: msg || 'Error',
          type: 'warning',
          duration: 5 * 1000
        })
        return Promise.reject(new Error(response.data.message || 'Error'))
        // return response.data.message
      }
      return response.data.data
    }
  },
  error => {
    const response = error.response
    const config = (response && response.config) || {}
    // 401(token 过期/被踢) → 跳 keycloak 登录页；置于 403 刷新与后续处理之前
    if (response && response.status === 401) {
      handleUnauthorized()
      return Promise.reject(error)
    }
    if (response && response.status === 403 && !config.__permissionRefreshRetried && canRefreshKeycloakToken()) {
      config.__permissionRefreshRetried = true
      // 权限上下文偶发未就绪时强制刷新一次 token；真实无权限只重试一次。
      return refreshKeycloakToken(-1).then(({ attempted, token }) => {
        if (!attempted || !token) return handleResponseError(error)
        return store.dispatch('account/keycloakLogin', token).then(() => {
          config.headers = config.headers || {}
          config.headers['Authorization'] = 'Bearer ' + token
          // axios 0.18已将baseURL合入config.url，重试时不能再次拼接。
          config.baseURL = ''
          return service(config)
        })
      }, () => handleResponseError(error))
    }
    return handleResponseError(error)
  }
)

function handleResponseError(error) {
  const response = error.response
  if (!response) {
    Message({
      message: error.message || '网络连接失败',
      type: 'error',
      center: true,
      duration: 5 * 1000
    })
    return Promise.reject(error)
  }
  const data = response.data || {}
  const config = response.config || {}
  if (data.message) {
    error.message = data.message
  }
  if (Reflect.has(config, 'isSelfHandler') && config.isSelfHandler) {
    return Promise.reject(response)
  }
  Message({
    message: error.message,
    type: 'error',
    center: true,
    duration: 5 * 1000
  })
  return Promise.reject(error)
}

export default service
